import type { UIMessage } from "ai";
import { useCallback } from "react";
import { appendUserTextMessage } from "./appendUserTextMessage";

export function useAppendUserChatMessage(
  messages: UIMessage[],
  setMessages: (messages: UIMessage[] | ((prev: UIMessage[]) => UIMessage[])) => void
) {
  return useCallback(
    (userText: string, metadata?: unknown) => {
      const next = appendUserTextMessage(messages, userText, metadata);
      setMessages(next);
      return next;
    },
    [messages, setMessages]
  );
}
